import { CompProps } from '@fable/types'
import { useStats } from './lib/ctx/stats'
import { StatsModalProvider } from './lib/ctx/stats_modal'
import { ReadingGoalsProvider } from './lib/ctx/reading_goals'

export const StatsProfileProviders = ({ children }: CompProps) => {
  const [stats, statsUserId, year, isWeb] = useStats((s) => [
    s.stats,
    s.statsUserId,
    s.year,
    s.isWeb,
  ])

  return (
    <>
      <StatsModalProvider>
        <ReadingGoalsProvider
          statsUserId={statsUserId}
          year={year}
          goalOptIn={!!stats?.goal_opt_in}
          isWeb={!!isWeb}
        >
          {children}
        </ReadingGoalsProvider>
      </StatsModalProvider>
    </>
  )
}
